// RuleTestPlaygroundLocalStorage.js
import React, { createContext, useState } from 'react';

const RuleTestPlaygroundLocalStorage = createContext();

export const RuleTestPlaygroundProvider = ({ children }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [ruleText, setRuleText] = useState('');
  const [output, setOutput] = useState('');
  const [isConditionChecked, setIsConditionChecked] = useState(false);
  const [conditionText, setConditionText] = useState('');
  const [modalData, setModalData] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);   // ✅ NEW
  const [dots, setDots] = useState('');                    // ✅ NEW

  return (
    <RuleTestPlaygroundLocalStorage.Provider
      value={{
        selectedFile,
        setSelectedFile,
        ruleText,
        setRuleText,
        output,
        setOutput,
        isConditionChecked,
        setIsConditionChecked,
        conditionText,
        setConditionText,
        modalData,
        setModalData,
        isAnalyzing,         // ✅ expose
        setIsAnalyzing,      // ✅ expose
        dots,                // ✅ expose
        setDots              // ✅ expose
      }}
    >
      {children}
    </RuleTestPlaygroundLocalStorage.Provider>
  );
};

export default RuleTestPlaygroundLocalStorage;

